import axios from "axios";
import Dropdown from "components/Dropdown/Dropdown";
import InputField from "components/forms/InputField/InputField";
import { useEffect, useState } from "react";
import { url } from "../../../../url";
import { useUser } from "hooks/useUser";
import styles from "../../../BusinsessRegistration/businessregistration.module.scss";
import RelativeInfobox from "components/RealtiveInfoBox/RelativeInfobox";
import { useMutation, useQuery } from "@tanstack/react-query";
import DeleteBusinessButton from "../../../../components/forms/DeleteBusiness/DeleteBusinessButton";
import Loading from "components/loading/Loading";
import { sellerTypes, statesTypes } from "utils/enums";

interface SellerFormData {
  name: string;
  type: string;
  description: string;
  email: string;
  phone: number | undefined;
  link: string;
  street: string;
  apartment: string;
  city: string;
  state: string;
  zipCode: string;
  country: string;
}

export default function Seller() {
  const [businessError, setBusinessError] = useState<string>("");
  const [emailError, setEmailError] = useState<string>("");
  const [stateError, setStateError] = useState<string>("");
  const [errorSellerType, setErrorSellerType] = useState<string>("");
  const { setDataChangeStatus, setIsError, userData } = useUser();

  const [sellerFormData, setSellerFormData] = useState<SellerFormData>({
    name: "",
    type: "",
    description: "",
    email: "",
    phone: undefined,
    link: "",
    street: "",
    apartment: "",
    city: "",
    state: "",
    zipCode: "",
    country: "",
  });

  const [stateType, setStateType] = useState<string>("Województwo");
  const [sellerType, setSellerType] = useState<string>("Typ sklepu");

  const getBusinessData = async () => {
    let response;
    try {
      response = await axios.get(url + "/user/business", {
        headers: {
          "Content-Type": "application/json",
        },
        withCredentials: true,
      });
    } catch (error: any) {
      response = error.response;
      console.log(response);
    }
    return response.data.business;
  };

  const handleSellerChange = (event: any) => {
    const { name, value } = event.target;
    setSellerFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };
  const handleSellerTypeChange = (key: string, value: string) => {
    setSellerFormData((prevState) => ({
      ...prevState,
      [key]: value,
    }));
  };

  const handleFormSubmit = async (event: any) => {
    setBusinessError("");
    setEmailError("");
    setStateError("");
    setErrorSellerType("");
    const token = localStorage.getItem("token");

    if (!/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/.test(sellerFormData.email)) {
      setEmailError("Prosze podać poprawny adres email.");
      event.preventDefault();
      return;
    }
    if (token) {
      mutate({ formData: sellerFormData });
      event.preventDefault();
    }
    event.preventDefault();
  };

  const changeBusiness = async ({ formData }: { formData: SellerFormData }) => {
    let response;
    try {
      response = await axios.patch(url + "/user/business", formData, {
        headers: {
          "Content-Type": "application/json",
        },
        withCredentials: true,
      });
    } catch (error: any) {
      response = error.response;
      console.log(response);
    }
    return response.data.business;
  };

  const { data, isLoading, error } = useQuery({
    queryKey: ["business"],
    queryFn: () => getBusinessData(),
  });

  const { mutate } = useMutation({
    mutationFn: changeBusiness,
    onSuccess: (data: any) => {
      console.log(data.message);
      if (data.status === 500) {
        if (
          data.message ===
          "Seller validation failed: type: `` is not a valid enum value for path `type`."
        ) {
          setErrorSellerType("Wybierz typ sprzedawcy");
        }
        if (
          data.message ===
          "Seller validation failed: type: `` is not a valid enum value for path `type`., state: `` is not a valid enum value for path `state`."
        ) {
          setErrorSellerType("Wybierz typ sprzedawcy");
          setStateError("Wybierz województwo");
        }
      } else {
        setDataChangeStatus(`Udało się zmienić dane!`);
        setIsError(false);
      }
    },
  });

  useEffect(() => {
    if (data) {
      setSellerFormData({
        name: data.name,
        type: data.type,
        description: data.description,
        email: data.email,
        phone: data.phone,
        link: data.link,
        street: data.street,
        apartment: data.apartment,
        city: data.city,
        state: data.state,
        zipCode: data.zipCode,
        country: data.country,
      });
      setSellerType(data.type);
      setStateType(data.state);
    }
  }, [data]);

  return (
    <>
      {!isLoading ? (
        <>
          <form className={styles.box__form} onSubmit={handleFormSubmit}>
            <div className={styles.box__inputBox}>
              <InputField
                label={"Nazwa sklepu"}
                name={"name"}
                value={sellerFormData.name}
                onChange={handleSellerChange}
                error={""}
                type={"text"}
                required
                length={100}
              />

              <Dropdown
                //label={"Typ sprzedawcy"}
                dropButtonName={sellerType}
                dropDownData={sellerTypes}
                setButtonName={setSellerType}
                handleChange={handleSellerTypeChange}
                changeType="type"
                error={errorSellerType}
              />
            </div>
            <div className={styles.box__inputBox}>
              <InputField
                label={"Adres email"}
                name={"email"}
                value={sellerFormData.email}
                onChange={handleSellerChange}
                error={emailError}
                type={"text"}
                required
                length={254}
              />
              <InputField
                label={"Numer telefonu"}
                name={"phone"}
                value={sellerFormData.phone}
                onChange={handleSellerChange}
                error={""}
                type={"number"}
                required
                length={15}
              />
            </div>
            <div className={styles.box__inputBox}>
              <InputField
                label={"Ulica"}
                name={"street"}
                value={sellerFormData.street}
                onChange={handleSellerChange}
                error={""}
                type={"text"}
                required={false}
                length={100}
              />
              <InputField
                label={"Numer budynku"}
                name={"apartment"}
                value={sellerFormData.apartment}
                onChange={handleSellerChange}
                error={""}
                type={"text"}
                required={false}
                length={10}
              />
            </div>
            <div className={styles.box__inputBox}>
              <InputField
                label={"Kod pocztowy"}
                name={"zipCode"}
                value={sellerFormData.zipCode}
                onChange={handleSellerChange}
                error={""}
                type={"text"}
                required={false}
                length={11}
              />
              <InputField
                label={"Miasto"}
                name={"city"}
                value={sellerFormData.city}
                onChange={handleSellerChange}
                error={""}
                type={"text"}
                required={false}
                length={58}
              />
            </div>
            <div className={styles.box__inputBox}>
              <Dropdown
                dropButtonName={stateType}
                dropDownData={statesTypes}
                setButtonName={setStateType}
                handleChange={handleSellerTypeChange}
                changeType="state"
                error={stateError}
              />
              <InputField
                label={"Państwo"}
                name={"country"}
                value={sellerFormData.country}
                onChange={handleSellerChange}
                error={""}
                type={"text"}
                required={false}
                length={56}
              />
            </div>
            <InputField
              label={"Adres strony sklepu"}
              name={"link"}
              value={sellerFormData.link}
              onChange={handleSellerChange}
              error={""}
              type={"text"}
              required={false}
              length={2048}
            />
            <InputField
              label={"Opis sklepu"}
              name={"description"}
              value={sellerFormData.description}
              onChange={handleSellerChange}
              error={""}
              type={"text"}
              required
              length={1000}
            />
            {/* <RelativeInfobox /> */}
            <button className={styles.box__changeData} type="submit">
              Zmień dane
            </button>
          </form>
          <DeleteBusinessButton
            label={"Czy na pewno chcesz usunąć działalność?"}
          />
        </>
      ) : (
        <Loading />
      )}
    </>
  );
}
